import { WebPushService } from "@repo/share-log-web-push";
import { API } from "@web/api";

export const webPushService = new WebPushService(API.push);
